import { render } from "./input-checkbox.vue?vue&type=template&id=80de3cc2&scoped=true"
import script from "./input-checkbox.vue?vue&type=script&lang=js"
export * from "./input-checkbox.vue?vue&type=script&lang=js"

import "./input-checkbox.vue?vue&type=style&index=0&id=80de3cc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80de3cc2"]])

export default __exports__